import { collection, query, where, getDocs, writeBatch, QueryDocumentSnapshot } from 'firebase/firestore';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { AsyncThunkCreator } from '../../../index';
import { NOTIFICATIONS_REDUCER_NAME } from '../types';
import { COLLECTION } from '../../../../firestore/collectionNames';
import { splitIntoChunks } from '../../../../helpers/splitIntoChunks';
import { BATCH_SIZE_LIMIT } from '../../../../constants/firestore';
import { NotificationStatus } from '../../../../models/documents';

export const markAllAsRead = createAsyncThunk<void, void, AsyncThunkCreator<number>>(
  `${NOTIFICATIONS_REDUCER_NAME}/markAllAsRead`,
  async (_, { rejectWithValue, extra: { auth, db } }) => {
    try {
      const user = auth().currentUser;
      if (!user) {
        throw new Error('user-is-not-logged');
      }
      const notificationsRef = collection(db, COLLECTION.USERS, user.uid, COLLECTION.NOTIFICATIONS);
      const q = query(notificationsRef, where('status', '==', NotificationStatus.UNREAD));

      const allUnread = await getDocs(q);

      const chunks = splitIntoChunks(allUnread.docs, BATCH_SIZE_LIMIT);

      for (const chunk of chunks) {
        const batch = writeBatch(db);
        chunk.forEach((doc: QueryDocumentSnapshot) => {
          batch.update(doc.ref, {
            status: NotificationStatus.READ,
          });
        });

        await batch.commit();
      }
    } catch (e) {
      const error = e as any;

      return rejectWithValue(error.message);
    }

    return;
  }
);
